<template>
  <v-dialog v-model="show" width="80%">
    <v-card>
      <v-card-title style="padding-left: 8px; padding-bottom: 8px">
        <span class="headline">{{ $t("B0300.titles[5]") }}</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="search" class="btn-search">{{
          $t("app.buttons.search")
        }}</v-btn>
        <v-btn @click="submit">{{ $t("app.buttons.apply") }}</v-btn>
        <v-btn @click="cancel">{{ $t("app.buttons.back") }}</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.poNo')"
                clearable
                v-model="query.orderNo"
              ></v-text-field>
            </v-flex>
            <!-- <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="海外取引先"
                url="companies/kv?type=PARTNER"
                v-model="query.partnerId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="LOADING PORT"
                url="ports/kv"
                v-model="query.loadingPortCode"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="DISCHARGE PORT"
                url="ports/kv"
                v-model="query.dischargePortCode"
              />
            </v-flex> -->
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.bu.name')"
                url="divisions/kv?type=BU"
                v-model="query.buId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.lotNo')"
                clearable
                v-model="query.lotNo"
              ></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.skuCode')"
                clearable
                v-model="query.skuCode"
              ></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.skuSupplierCode')"
                clearable
                v-model="query.skuSupplierCode"
              ></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.siNo')"
                clearable
                v-model="query.siNo"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
      <v-data-table
        :headers="headers"
        :items="results"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        class="elevation-0"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td width="20">
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td>{{ props.item.poNo }}</td>
          <td>{{ props.item.siNo }}</td>
          <td>{{ props.item.buCode }}:{{ props.item.buName }}</td>
          <td>{{ props.item.departmentName }}</td>
          <td>{{ props.item.lotNo }}</td>
          <td>{{ props.item.skuCode }}</td>
          <td>{{ props.item.skuSupplierCode }}</td>
          <td>{{ props.item.qty }}</td>
          <td>{{ props.item.leftInvoice }}</td>
          <td>{{ props.item.payment }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["invoice"],
  data() {
    return {
      query: {},
      show: false,
      resolve: null,
      reject: null,
      selected: [],
      results: [],
      headers: [
        { text: this.$t("app.labels.poNo"), value: "poNo", sortable: false },
        { text: this.$t("app.labels.siNo"), value: "siNo", sortable: false },
        {
          text: this.$t("app.labels.bu.name"),
          value: "bu.name",
          sortable: false,
        },
        {
          text: this.$t("app.labels.department.name"),
          value: "department.name",
          sortable: false,
        },
        { text: this.$t("app.labels.lotNo"), value: "lotNo", sortable: false },
        {
          text: this.$t("app.labels.skuCode"),
          value: "sku.code",
          sortable: false,
        },
        {
          text: this.$t("app.labels.skuSupplierCode"),
          value: "sku.supplierCode",
          sortable: false,
        },
        { text: this.$t("B0300.labels.po.qty"), value: "qty", sortable: false },
        {
          text: this.$t("B0300.labels.po.leftInvoice"),
          value: "leftInvoice",
          sortable: false,
        },
        {
          text: "payment",
          value: "payment",
          sortable: false,
        },
      ],
      pagination: {
        rowsPerPage: 20,
        page: 1,
      },
    };
  },
  methods: {
    search() {
      this.pagination.page = 0;
      this.load();
    },
    load() {
      this.autoload = true;
      this.$storeParams();
      this.loading = true;
      this.$http
        .get("purchase-orders", {
          params: { ...this.query, ...this.$pageable(), sort: "poNo" },
        })
        .then((res) => {
          this.pagination.page = res.data.number + 1;
          this.pagination.rowsPerPage = res.data.size;
          this.pagination.totalItems = res.data.totalElements;
          this.results = res.data.content;
          this.loading = false;
          this.selected = [];
        });
    },
    submit() {
      if (
        !this.sameLoadingPort(this.selected) ||
        !this.sameDischargePort(this.selected)
      ) {
        this.$confirm({
          content:
            "P/Oの積出港・陸揚港とINVの積出港・陸揚港が不一致ですが、次に進めますか？",
        }).then(() => {
          this.doCommit();
        });
      } else {
        this.doCommit();
      }
    },
    doCommit() {
      this.show = false;
      this.resolve(this.selected);
      this.selected = [];
    },
    popup() {
      this.show = true;
      // this.load()
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    cancel() {
      this.query = {};
      // this.pagination = {
      //   rowsPerPage: 5,
      //   page: 1
      // }
      this.show = false;
    },
    sameLoadingPort(item) {
      var a = item
        .filter((p) => p.loadingPortCode != null)
        .map((p) => p.loadingPortCode)
        .reduce((total, code) => {
          if (total.indexOf(code) == -1) {
            total.push(code);
          }
          return total;
        }, []);
      console.log(a);
      if (a.length > 1) {
        return false;
      } else if (
        this.invoice.items &&
        this.invoice.items.length > 0 &&
        this.invoice.items[0].loadingPortCode != a[0]
      ) {
        return false;
      } else {
        return true;
      }
    },
    sameDischargePort(item) {
      var a = item
        .filter((p) => p.dischargePortCode != null)
        .map((p) => p.dischargePortCode)
        .reduce((total, code) => {
          if (total.indexOf(code) == -1) {
            total.push(code);
          }
          return total;
        }, []);
      if (a.length > 1) {
        return false;
      } else if (
        this.invoice.items &&
        this.invoice.items.length > 0 &&
        this.invoice.items[0].dischargePortCode != a[0]
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {
    pagination() {
      if (this.autoload) this.load();
    },
  },
};
</script>
